import { shallowEqual, useSelector } from 'react-redux';
import { getTrustUser } from '../selectors';

export const useTrustUser = () => ({
  trust: useSelector(getTrustUser, shallowEqual),
});
